import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {IAssociationSegment} from '../../_models/AssociationSegment';
import {BaseHubService} from './base-hub.service';
import {MessageService} from '../local/message.service';
import {ConfigService} from '../local/config.service';
import {IBaseObject} from '../../_models/BaseObject';

@Injectable({
  providedIn: 'root',
})
export class AsService extends BaseHubService<IAssociationSegment> {
  constructor(
    http: HttpClient,
    messageService: MessageService,
    configService: ConfigService
  ) {
    super(
      'plans-gestion-mobilite/associations-segments',
      'hubs/pgmSegmentHub',
      'Associations segments',
      http,
      messageService,
      configService
    );
  }

  refreshHubConnection(): Promise<void> {
    return this.start();
  }

  protected dispatchUpdateData(data: IBaseObject[]): void {
  }
}
